import React from 'react';
import { useTitle } from "fearless-common-ui";
import {adminRoutes} from "../../../utils/routes";
import Pages from "../../../components/layout/Pages";
import {ColumnDef} from "@tanstack/react-table";
import OrderableTable from "../../../components/layout/OrderableTable";
import {concepts, explanations, Institute, SubscriptionRule} from "fearless-common";
import Button from "react-bootstrap/Button";
import {PlusLg} from "react-bootstrap-icons";
import {backendEndpoints} from "../../../libs/backendEndpoints";
import useGet from "../../../components/hooks/useGet";
import CellRender from "../../../components/layout/table/CellRender";

const columns: ColumnDef<SubscriptionRule & { institute: Institute }>[] = [
    { id: 'id', accessorKey: 'id', header: 'ID', enableSorting: true },
    { id: 'product', accessorKey: 'product', header: 'Product', enableSorting: true },
    { id: 'title', accessorKey: 'title', header: 'Title', enableSorting: false },
    {
      id: 'institute',
      // @ts-ignore TS does not support nested property checks, but the accessor allows it.
      accessorKey: 'institute.name',
      header: 'Institute',
      enableSorting: false
    },
    { id: 'type', accessorKey: 'type', header: 'Type', enableSorting: true },
    { id: 'value', accessorKey: 'value', header: 'value', enableSorting: true },
    { id: 'n_users_following_rule', accessorKey: 'n_users_following_rule', header: '# users', enableSorting: false },
    { id: 'created_at', accessorKey: 'created_at', header: 'Created at', cell: CellRender.Date, enableSorting: false },
]

export default function AdminSubscriptionRules() {
    useTitle(`Admin ${concepts.SubscriptionRules}`);

    const { data: institutes } = useGet<Institute[]>({ endpoint: backendEndpoints.getAdminInstitutes })
    const { data: ruleTypes } = useGet<Record<string, string>>({ endpoint: backendEndpoints.adminSubscriptionRuleTypes })

    return (
        <Pages.Centred padded>
            <div className="d-inline-flex align-items-center gap-4">
                <h1>{concepts.SubscriptionRules}</h1>
                <Button size="sm" href={adminRoutes.addSubscriptionRule} variant="outline-primary"><PlusLg /> add</Button>
            </div>
            <p>{explanations.WhatAreSubscriptionRules}</p>
            <OrderableTable
                filterables={[
                  {
                    field_name: 'institute_id',
                    label: 'Institute',
                    options: institutes?.map((i) => ({ value: i.id.toString(), label: i.name})) || [],
                  },
                  {
                    field_name: 'type',
                    label: 'Type',
                    options: ruleTypes ? Object.keys(ruleTypes).map((r) => (
                      { value: r, label: ruleTypes[r] }
                    )) : [],
                  }
                ]}
                baseEndpoint={backendEndpoints.getSubscriptionRules}
                memoisedColumns={columns}
                buildLink={(record) => adminRoutes.subscriptionRule(record.id)}
            />
        </Pages.Centred>
    );
}
